import { IonContent, IonItem, IonList, IonMenu } from '@ionic/react';
import { AppLogoDesktop } from './AppLogoDesktop';
import { AppConfigType } from './types';
import { useLocationRedirector } from '../pages/user/catalog/hook.useLocationRedirector';

export const AppMenu: React.FC<{
  config: AppConfigType;
  isFormPage: boolean;
  pathName: string;
}> = ({ config, isFormPage, pathName }) => {
  //
  // TODO: fix loosing of all search params by providing searchParams context
  const catalogLink = useLocationRedirector({ allowSet: false }) || '/catalog';

  //
  // TODO ASAP:
  // Introduce routing like <IonTab>
  // Or wait when Ionic will support react-router v6
  // Now ProductDetail stays in stack forever -> leads to memory leak

  return (
    <IonMenu contentId="main">
      <AppLogoDesktop />

      <IonContent>
        <IonList>
          {config.map(cfg => {
            const isActive = cfg.link.startsWith('/catalog')
              ? pathName.startsWith('/catalog')
              : pathName.startsWith(cfg.link);

            return (
              <IonItem
                key={cfg.name}
                style={{
                  margin: '5px',
                  borderRadius: '10px',
                  '--background': isActive ? 'grey' : '',
                }}
                // Pages was not unmounted, so we used to apply this workaround
                // https://github.com/ionic-team/ionic-framework/issues/20597
                routerDirection={isFormPage ? 'back' : 'none'}
                routerLink={
                  cfg.link.startsWith('/catalog') ? catalogLink : cfg.link
                }
              >
                <p>{cfg.name}</p>
              </IonItem>
            );
          })}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};
